<div class="side-accordion" *ngIf="!isMobile">
  <ul class="side-accordion__list">
    <li class="side-accordion__list-item" [ngClass]="{'side-accordion__list-item--active': activeItem.id === item.id}"
      *ngFor="let item of items" (click)="setBodyData(item)" l10nTranslate>
      {{item.title}}
    </li>
  </ul>
  <div class="side-accordion__body">
    <h2 l10nTranslate>{{activeItem.title}}</h2>
    <ul *ngFor="let item of activeItem.body">
      <li l10nTranslate>{{item}}</li>
    </ul>
  </div>
</div>


<div class="expansion-panel" *ngIf="isMobile">
  <div class="expansion-panel__container">
    <mat-accordion>
    <mat-expansion-panel *ngFor="let item of items; let i = index" [expanded]="i == 0" (click)="setBodyData(item)" (opened)="panelOpenState = true"
      (closed)="panelOpenState = false">
      <mat-expansion-panel-header>
        <mat-panel-title l10nTranslate>{{item.title}}</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-panel__descriptions-holder">
        <ul class="expansion-panel__description" *ngFor="let item of activeItem.body">
          <li l10nTranslate>{{item}}</li>
        </ul>
      </div>
      <section class="section-image">
      </section>
    </mat-expansion-panel>
  </mat-accordion>
  </div>
</div>